import { CircularProgress } from '@material-ui/core'

import { Align } from '../Align'

export const LoadingSpinner = () => (
  <Align justify='center' align='center' style={{ marginTop: 40 }}>
    <CircularProgress />
  </Align>
)
